import { ActivityItem } from './types';
import { EXPECTED_DURATION_IN_MINUTES } from './constants';

export const convertTimeToMinutes = (duration: number): string => {
  const hours = Math.floor(duration / 60);
  const timeInHoursAndMinutes = `${hours ? `${hours} hr` : ''} ${
    duration % 60 ? `${duration % 60} min` : '0 min'
  }`;
  return timeInHoursAndMinutes;
};
export const calculateActivityBarWidths = (
  activities: ActivityItem[],
  expectedDurationInMinutes: number
): ActivityItem[] => {
  const expectedMinutes = expectedDurationInMinutes;

  let totalMinutes = 0;
  const activitiesWithMinutes = activities.map(activity => {
    const minutes = activity.durationInMinutes;
    totalMinutes += minutes;
    return { ...activity };
  });

  const maxMinutes = Math.max(totalMinutes, expectedMinutes);

  const result = activitiesWithMinutes.map(activity => ({
    ...activity,
    durationInPercentage: (activity.durationInMinutes / maxMinutes) * 100
  }));

  if (totalMinutes < expectedMinutes) {
    result.push({
      type: 'empty',
      durationInMinutes: 0,
      durationInPercentage: ((expectedMinutes - totalMinutes) / maxMinutes) * 100
    });
  }

  return result;
};

export const calculateTargetPosition = (
  expectedDurationInMinutes: number,
  activities: ActivityItem[]
): number => {
  const expectedDurationTarget = expectedDurationInMinutes || EXPECTED_DURATION_IN_MINUTES;

  let totalMinutes = 0;
  activities.forEach(activity => {
    totalMinutes += activity.durationInMinutes;
  });

  const maxMinutes = Math.max(totalMinutes, EXPECTED_DURATION_IN_MINUTES);
  return (expectedDurationTarget / maxMinutes) * 100;
};

export const getActivityColorClassMap = {
  lateLogin: 'var(--red-crisis)',
  inTimeLogin: 'var(--blue-base)',
  active: 'var(--blue-border)',
  training: 'var(--blue-light-1)',
  meeting: 'var(--navi-color-orange-border)',
  morning: 'var(--blue-border)',
  lunch: 'var(--blue-light-1)',
  evening: 'var(--navi-color-orange-border)',
  others: 'var(--navi-color-violet-border)',
  empty: 'var(--bg-primary)',
  callsSelfCall: 'var(--navi-color-red-light)'
};

export const isLateLogin = (loginTimeStamp: number): boolean => {
  const loginTime = new Date(loginTimeStamp);
  return (
    loginTime &&
    (loginTime.getHours() > 9 ||
      (loginTime.getHours() === 9 && loginTime.getMinutes() >= 30 && loginTime.getSeconds() >= 23))
  );
};

export const getCallTypeClass = (numberOfCalls: number): string => {
  if (numberOfCalls >= 50) {
    return 'var(--blue-dark-1)';
  } else if (numberOfCalls > 30) {
    return 'var(--blue-light-2)';
  } else if (numberOfCalls > 0) {
    return 'var(--blue-light-3)';
  } else {
    return 'var(--bg-primary)';
  }
};
